import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import useToast from "../../../../../hooks/useToast";
import AutreCompetenceNiveau from "./AutreCompetenceNiveau";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import { useQuery } from "../../../../../hooks/useQuery";
import { CVAutreCompetenceService } from "../../../../../service/CVAutreCompetenceService";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
import { useToastStore } from "../../../../../stores/toastStore";
const INIT_AUTRE_COMPETENCE = {
  id_autre_competence: null,
  competence: "",
  type: "",
  niveau: "",
};

const INIT_FORM_ERROR = {
  competence_error: null,
  type_error: null,
  niveau_error: null,
};
const AutreCompetenceForm = ({
  open,
  onFormClose,
  onFormOpen,
  idAutreCompetence,
}) => {
  const [currentAutreCompetence, setCurrentAutreCompetence] = useState(
    INIT_AUTRE_COMPETENCE,
  );
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const options = ["Langue", "Informatique", "Autre"];
  const showToastStore = useToastStore((state) => state.showToast);
  const query = useQuery();
  const user_id = query.get("ref");
  const handleFormClose = () => {
    onFormClose();
    initAll();
  };

  const initAll = () => {
    setCurrentAutreCompetence(INIT_AUTRE_COMPETENCE);
    setFormErrors(INIT_FORM_ERROR);
    setIsSubmitted(false);
    setLoading(false);
  };

  const handleChangeCurrentAutreCompetence = (e) => {
    const { name, value } = e.target;
    setCurrentAutreCompetence((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleFetchData = () => {
    setFormLoading(true);
    CVAutreCompetenceService.find_by_id(idAutreCompetence)
      .then((res) => {
        if (res && res.data) {
          setCurrentAutreCompetence(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const handleCheckError = () => {
    setFormErrors({
      competence_error: !currentAutreCompetence.competence
        ? "Champ compétence requis"
        : ["Autre", "Autres"].includes(
              String(currentAutreCompetence.competence).trim(),
            )
          ? "Veuillez saisir votre domaine (au lieu de Autre(s))"
          : null,
      type_error: !currentAutreCompetence.type ? "Champ type requis" : null,
      niveau_error: !currentAutreCompetence.niveau
        ? "Champ niveau requis"
        : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleInsertAutreCompetence = () => {
    setSubmitting(true);
    CVAutreCompetenceService.insert({
      ...currentAutreCompetence,
      id_ext_user: user_id,
    })
      .then((res) => {
        if (res && res.success) {
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  const handleUpdateAutreCompetence = () => {
    setSubmitting(true);
    CVAutreCompetenceService.update(currentAutreCompetence)
      .then((res) => {
        if (res && res.success) {
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (handleCheckError()) {
      setLoading(true);
      if (idAutreCompetence) {
        handleUpdateAutreCompetence();
      } else {
        handleInsertAutreCompetence();
      }
    } else {
      showToastStore(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez remplir tous les champs obligatoires",
      );
    }
  };

  useEffect(() => {
    if (open && idAutreCompetence) handleFetchData();
  }, [open, idAutreCompetence]);

  useEffect(() => {
    handleCheckError();
  }, [currentAutreCompetence]);

  return (
    <>
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <StandardSkeletoon show={formLoading} escalier row={3} />
          <Grid display={formLoading ? "none" : ""}>
            <CardHeader title="Autre competence" />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Domaine *</label>
                  <Autocomplete
                    freeSolo
                    name="competence"
                    id="competence"
                    options={options}
                    value={currentAutreCompetence.competence || ""}
                    onChange={(event, newValue) => {
                      handleChangeCurrentAutreCompetence({
                        target: { name: "competence", value: newValue || "" },
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      handleChangeCurrentAutreCompetence({
                        target: {
                          name: "competence",
                          value: newInputValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="competence"
                        name="competence"
                        size="small"
                        placeholder="Compétence"
                        fullWidth
                        error={formErrors.competence_error && isSubmitted}
                        helperText={
                          isSubmitted ? formErrors.competence_error : ""
                        }
                        aria-describedby="competence_helper"
                      />
                    )}
                  />
                  <FormHelperText id="competence_helper"></FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{
                    display:
                      /*   ["Langue", "Informatique"].includes(
                        currentAutreCompetence.competence,
                      ) || !currentAutreCompetence.competence
                        ? "none"
                        : "block", */
                      "none",
                  }}
                >
                  <label>Autre domaine *</label>
                  <TextField
                    id="domaine"
                    name="competence"
                    onChange={handleChangeCurrentAutreCompetence}
                    size="small"
                    placeholder="Domaine de competence"
                    fullWidth
                    value={currentAutreCompetence.competence}
                    error={formErrors.competence_error && isSubmitted}
                    helperText={
                      isSubmitted && formErrors.competence_error
                        ? "Veuillez preciser votre domaine"
                        : ""
                    }
                    aria-describedby="domaine_helper"
                  />
                  <FormHelperText id="domaine_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Competence *</label>
                  <TextField
                    id="type"
                    name="type"
                    onChange={handleChangeCurrentAutreCompetence}
                    size="small"
                    placeholder="Type de Compétence"
                    fullWidth
                    value={currentAutreCompetence.type}
                    error={formErrors.type_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.type_error : ""}
                    aria-describedby="type_helper"
                  />
                  <FormHelperText id="type_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Niveau</label>
                  <TextField
                    sx={{ display: "none" }}
                    id="niveau"
                    name="niveau"
                    onChange={handleChangeCurrentAutreCompetence}
                    size="small"
                    placeholder="Niveau de competence"
                    fullWidth
                    value={currentAutreCompetence.niveau}
                    error={formErrors.niveau_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.niveau_error : ""}
                    aria-describedby="niveau_helper"
                  />
                  <AutreCompetenceNiveau
                    value={currentAutreCompetence.niveau.split(",") || []}
                    onChange={(val) =>
                      setCurrentAutreCompetence({
                        ...currentAutreCompetence,
                        niveau: val,
                      })
                    }
                    typeCompetence={currentAutreCompetence.competence}
                    error={formErrors.niveau_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.niveau_error : ""}
                  />
                  <FormHelperText id="niveau_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                text={"Enregistrer"}
                size={"medium"}
                variant={"contained"}
                onClick={handleSubmit}
                loading={loading}
              />
              <AppButton
                text={"Fermer"}
                onClick={handleFormClose}
                size={"medium"}
                variant={"outlined"}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default AutreCompetenceForm;
